import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import cns from 'classnames';
import { Link } from 'react-router-dom';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import { RuntimeContext } from '../../../../../common/RuntimeContext';
import moment from 'moment';
import VerbButton, { VERB_BUTTON_TYPE } from '../../../../shared/components/VerbButton';
import { getFileSize } from '../../../../shared/utils/NumberUtils';

const MediaLibraryRow = ({
    fileMetadata = {
        uploadedBy: {
            firstName: '',
            lastName: ''
        }
    },
    index,
    handleDeleteFile,
    downloadFile,
    setCopiedUrl,
    canEdit
}) => {
    const config = useContext(RuntimeContext);
    return (
        <tr className={cns('file-metadata-row', { even: index % 2 === 0 })}>
            <td className={'button-container'}>
                {canEdit ? (
                    <Link to={`/editmedialibraryfile/${fileMetadata._id}`}>
                        <VerbButton buttonType={VERB_BUTTON_TYPE.SECONDARY_DETAILS} fontAwesomeIcon={'fa-pencil'} />
                    </Link>
                ) : null}
                <CopyToClipboard text={`${config.pathsWeb.mediaLibraryUrl}/file/${fileMetadata.key}`}>
                    <VerbButton
                        buttonType={VERB_BUTTON_TYPE.SECONDARY_DETAILS}
                        fontAwesomeIcon={'fal fa-clipboard'}
                        onClick={() => {
                            setCopiedUrl(fileMetadata);
                        }}
                    />
                </CopyToClipboard>
                <VerbButton
                    buttonType={VERB_BUTTON_TYPE.SECONDARY_DETAILS}
                    fontAwesomeIcon={'fal fa-download'}
                    onClick={() => {
                        downloadFile(fileMetadata.key);
                    }}
                />
                {canEdit ? (
                    <VerbButton
                        buttonType={VERB_BUTTON_TYPE.SECONDARY_DETAILS}
                        fontAwesomeIcon={'fa-trash'}
                        onClick={() => handleDeleteFile(fileMetadata, index)}
                    />
                ) : null}
            </td>
            <td className={'file-name'}>{fileMetadata.fileName}</td>
            <td className={'file-size'}>{getFileSize(fileMetadata.size)}</td>
            <td className={'file-uploaded-date'}>{moment(fileMetadata.updatedOn).format('MMM DD, YYYY')}</td>
        </tr>
    );
};

MediaLibraryRow.propTypes = {
    fileMetadata: PropTypes.object,
    index: PropTypes.number,
    downloadFile: PropTypes.func,
    setCopiedUrl: PropTypes.func,
    handleDeleteFile: PropTypes.func,
    canEdit: PropTypes.bool
};

export default MediaLibraryRow;
